export default "__VITE_ASSET__151e2759__"